import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

const SessionSection = ({ sessions = [], handleShowSessionDetails }) => {
  return (
    <>
      <Typography
        variant='subtitle1'
        style={{ fontWeight: 700, color: '#6a1b9a', marginBottom: 8 }}
      >
        Sesiones
      </Typography>
      <div style={{ maxHeight: 350, overflowY: 'auto', padding: '0px 0px 14px' }}>
        <Grid container spacing={2} direction='column'>
          {sessions.map((session) => (
            <Grid item key={session.id}>
              <Card variant='outlined' style={{ minWidth: 300 }}>
                <CardContent
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingBottom: 8,
                  }}
                >
                  <div>
                    {[
                      { label: 'ID Sesión:', value: session.id, variant: 'subtitle2' },
                      { label: 'Entrevista:', value: session.interview_id },
                      { label: 'Estatus:', value: session.linked_up_status },
                      { label: 'Estatus ID:', value: session.linked_up_status_id },
                      { label: 'Creado:', value: convertToMexicoTime(session.created) },
                      { label: 'Actualizado:', value: convertToMexicoTime(session.updated) },
                    ].map((item, idx) => (
                      <Typography key={idx} variant={item.variant || 'body2'}>
                        <span style={{ color: '#422b4c', fontWeight: 700 }}>{item.label}</span>{' '}
                        {item.value}
                      </Typography>
                    ))}
                  </div>
                  <Button
                    variant='contained'
                    color='primary'
                    size='small'
                    onClick={() => handleShowSessionDetails && handleShowSessionDetails(session)}
                    style={{
                      marginLeft: 16,
                      minWidth: 80,
                      maxWidth: 120,
                      fontSize: 12,
                      padding: '4px 8px',
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    }}
                  >
                    <span style={{ fontSize: 'inherit', wordBreak: 'break-word' }}>
                      Ver más detalles
                    </span>
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
};

export default SessionSection;
